import './tailwind.css'
import { Chart, registerables } from 'chart.js'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { VendorI18nProvider } from './_supplier/i18n/Vendor18n'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './_supplier/assets/sass/plugins.scss'
import './_supplier/assets/sass/style.react.scss'
import './_supplier/assets/sass/style.scss'
import { AuthProvider } from './app/modules/auth'
import { WarehouseProvider } from './app/context/WarehouseContext'
import { AppRoutes } from './app/routing/AppRoutes'

Chart.register(...registerables)
const queryClient = new QueryClient()
const container = document.getElementById('root')

if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <VendorI18nProvider>
        <AuthProvider>
          <WarehouseProvider>
            <ToastContainer />
            <AppRoutes />
          </WarehouseProvider>
        </AuthProvider>
      </VendorI18nProvider>
    </QueryClientProvider>
  )
}
